import { Helmet } from "react-helmet";

import CAImage from "../assets/images/CommunityAccess.svg";

const CommunityAccess = () => {
  return (
    <main>
      <Helmet>
        <title>Community Access | Provido</title>
        <meta property="og:title" content="Community Access | Provido" />
        <meta
          name="description"
          content="We provide support for helping perople get out in the community."
        ></meta>
        <meta
          property="og:url"
          content="https://provido.com.au/services/community-access"
        />
        <meta name="twitter:title" content="Community Access | Provido" />
      </Helmet>

      {/* Page Header */}
      <div className="w-dvw bg-lightblue bg-[url(./assets/images/bubblebg.webp)] pt-12">
        <div className="mb-12 text-center font-display text-6xl leading-18 text-blue sm:pb-0">
          Community Access
        </div>
        <div className="mx-12 grid grid-cols-1 gap-8 md:grid-cols-2 lg:mx-24 lg:gap-24">
          <div className="order-2 flex items-center md:order-1">
            <img
              src={CAImage}
              className="-mt-6 -mb-0.5 max-h-96 w-full"
              alt="Illustration: four people grouped together, one with a thumbs up, and another with a peace sign."
            />
          </div>
          <div className="order-1 flex flex-col items-center pb-12 sm:gap-8 md:order-2">
            <p>
              We provide personalised support to assist participants in
              accessing social, recreational, educational, and everyday
              activities that align with their goals, interests, and lifestyle.
              Whether it's attending appointments, participating in community
              events, or exploring new opportunities, we're here to support
              meaningful participation and inclusion.
            </p>
          </div>
        </div>
      </div>

      {/* How We Can Help You */}
      <div className="px-6 py-16">
        <div className="mx-auto w-fit">
          <div className="flex flex-col justify-center">
            <h2 className="pb-12 text-center font-display text-4xl text-purple">
              How We Can Help You
            </h2>
            <h3 className="pb-1 font-display text-xl text-blue">
              Our Community Access services may assist with:
            </h3>
            <ul className="text-list">
              <li>Attending social and recreational activities</li>
              <li>Participating in community events</li>
              <li>Shopping and running errands</li>
              <li>Attending medical and allied health appointments</li>
              <li>Building social skills and confidence</li>
              <li>Developing independence and life skills</li>
              <li>Accessing educational or employment opportunities</li>
              <li>Visiting family and friends</li>
              <li>Exploring hobbies and personal interests</li>
              <li>Using public transport and navigating the community</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Who We Support */}
      <div className="w-dvw bg-skyblue bg-[url(./assets/images/darkbubblebg.webp)] px-8 py-24">
        <div className="mx-auto max-w-3xl text-white">
          <h2 className="pb-8 text-center font-display text-3xl text-blue lg:text-4xl">
            Who We Support?
          </h2>
          <p>
            We support participants living with a wide range of disabilities and
            support needs, including:
          </p>
          <ul className="text-list">
            <li>Intellectual disabilities</li>
            <li>Autism Spectrum Disorder (ASD)</li>
            <li>Physical disabilities</li>
            <li>Neurological conditions</li>
            <li>Psychosocial disabilities</li>
          </ul>
          <p>
            We are passionate about helping participants build connections,
            increase independence, and enjoy greater participation in the
            activities and communities that matter most to them.
          </p>
        </div>
      </div>
    </main>
  );
};

export default CommunityAccess;
